import Axios from 'axios'
import { ConnexionData } from '../components/Authentification/Connexion/Connexion.type'
import { InscriptionData } from '../components/Authentification/Inscription/Inscription.type'

import { SERVER_BASE_URL } from './baseUrl'

export const register = async (data: InscriptionData) => {
  try {
    return await Axios.post(`${SERVER_BASE_URL}api/users/register`, data)
  } catch (error) {
    console.error('Erreur lors de la requête :', error)
    throw error
  }
}

export const login = async (data: ConnexionData) => {
  try {
    return await Axios.post(`${SERVER_BASE_URL}api/users/authenticate`, data)
  } catch (error) {
    console.error('Erreur lors de la requête :', error)
    throw error
  }
}

export const resetPassword = async (email: string) => {
  try {
    const response = await Axios.put(`${SERVER_BASE_URL}api/users/reset-password`, {
      email: email,
    })
    return response.data
  } catch (error) {
    console.error('Erreur lors de la requête :', error)
    throw error
  }
}

export const authenticate = async () => {
  try {
    const response = await Axios.get(`${SERVER_BASE_URL}api/users/authenticate`)
    return response
  } catch (error) {
    console.error('Erreur lors de la requête :', error)
    throw error
  }
}

export const isAuthenticate = async (token: string) => {
  try {
    const response = await Axios.get(`${SERVER_BASE_URL}api/users/authenticate`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    return response.data // Supposons que les informations de l'utilisateur sont dans response.data
  } catch (error) {
    localStorage.removeItem('token')
    window.location.replace('/connexion')
    return
  }
}
